import React, { useEffect, useRef, useState } from 'react';
import ReactApexChart from "react-apexcharts";
import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import CLabel from '../../../../../Common/CLabel';
import PropTypes from 'prop-types';
import './radial.css'
import i18next from 'i18next';
import HEADER_TOOLBAR from '../HEADER_TOOLBAR';
import { TooltipHost } from '@fluentui/react';
import { useSelector } from 'react-redux';
import ItemGroup from './ItemGroup';
import { formatNumber, isNullUndefined, isNullUndefinedOrEmpty } from '../../../../../../common/Helpers';

function SG3KPI_RADIALOPF(props) {
	const { t, i18n } = useTranslation();

	const { 
		inputParam_HideHeader = false,
		inputParam_ComponentContent = null,
		inputParam_UseFake = false,
		inputParam_ReportHeaderMode = false,
		inputParam_BoardStructure = null,
        inputParam_Container = null
	} = props;

	const opf = !isNullUndefinedOrEmpty(inputParam_ComponentContent) ? inputParam_ComponentContent.items.find(x => x.name === "OPF") : null
	const castigo = !isNullUndefinedOrEmpty(inputParam_ComponentContent) ? inputParam_ComponentContent.items.find(x => x.name === "CASTIGO") : null
	const valorMaximo = 100;
	const valorEscalar = !isNullUndefinedOrEmpty(opf) ? ((opf.scopeValue / valorMaximo) * 100) : 0;

	const options = {
		chart: {
			type: 'radialBar',
			offsetY: -20,
			sparkline: {
				enabled: true
			},
			height: 300
		},
		plotOptions: {
			radialBar: {
				startAngle: -90,
				endAngle: 90,
				track: {
					background: "#e7e7e7",
					strokeWidth: '97%',
					margin: 5,
					dropShadow: {
						enabled: true,
						top: 2,
						left: 0,
						color: '#999',
						opacity: 1,
						blur: 2
					}
				},
				dataLabels: {
					name: {
					show: false
					},
					value: {
						offsetY: -2,
						fontSize: '22px',
						show : false
					}
				}
			}
		},
		colors: !isNullUndefinedOrEmpty(opf) ? [opf.color === 'r' ? '#d93b3b' : (opf.color === 'v' ? '#25aa34' : (opf.color === 'a' ? '#ECA700' : '#999999'))] : ['#999999'],
		grid: {
			padding: {
				top: -10
			}
		},
		fill: {
			type: 'solid',
			colors: !isNullUndefinedOrEmpty(opf) ? [opf.color === 'r' ? '#d93b3b' : (opf.color === 'v' ? '#25aa34' : (opf.color === 'a' ? '#ECA700' : '#999999'))] : ['#999999'], // Establecer el color de relleno
		},
	}
  
	const renderContent = () => {
		return  <div className='h-100'>
					<Row className='text-center'>
					</Row>
					<Row>
						<Col className='col-auto my-auto mx-auto'>
							<ReactApexChart
								options={options}
								series={[valorEscalar]}
								type="radialBar"
								height={300} />
						</Col>
					</Row>
					{
						isNullUndefined(castigo) &&
						<Row style={{marginTop: "-40px"}}>
							<Col>
								<Row>
									<Col className="col-auto mx-auto" style={{fontSize: "24px", fontWeight: "bold"}}>
										{ formatNumber(valorEscalar) }%
									</Col>
								</Row>
							</Col>
						</Row>
					}
					{
						!isNullUndefined(castigo) &&
						<Row style={{marginTop: "-93px"}}>
							<Col>
								<div className="row text-center">
									<Col xl={12} className="col-auto mx-auto" style={{fontSize: "24px", fontWeight: "bold"}}>
										{formatNumber(valorEscalar)}%
									</Col>
									<Col xl={12} className="col-auto mx-auto" style={{fontSize: "12px", fontWeight: "bold"}}>{t('data-lang-lbl-calculate')}</Col>
									<Col xl={12} className="col-auto mx-auto" style={{fontSize: "24px", fontWeight: "bold", color: "red"}}>{castigo.scopeValue.toFixed(2).toLocaleString(i18n.language)}%</Col>
									<Col xl={12} className="col-auto mx-auto" style={{fontSize: "12px", fontWeight: "bold"}}>{t('data-lang-lbl-punishment')}</Col>
								</div>
							</Col>
						</Row>
					}
					<Row>
						{
							inputParam_ComponentContent && inputParam_ComponentContent.items.filter(x => x.name !== "OPF").map((item, index) => 
								<Col key={index} xl={6} className='col-auto mx-auto px-1 mt-0 mb-1 border'>
									<ItemGroup inputParam_Key={ index } inputParam_Object={item} />
								</Col>
							)
						}
					</Row>
				</div>
	}

	return  <>
	{
		!inputParam_UseFake &&
		<Card className='board-element-form h-100'>
			{
				!inputParam_HideHeader &&
				<>
					{
						inputParam_ReportHeaderMode ?
						<Card.Body className='p-0 m-0 text-start rounded-top' style={{fontSize: "13px", fontWeight: "bolder", backgroundColor: "#e3e6f3", color: "darkblue"}}>
							<TooltipHost content={inputParam_ComponentContent !== null ? (inputParam_ComponentContent.boardComponentTitle ?? t('data-lang-boxname-radial_opf')) : t('data-lang-boxname-radial_opf')}>
								<div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
									{inputParam_ComponentContent !== null ? (inputParam_ComponentContent.boardComponentTitle ?? t('data-lang-boxname-radial_opf')) : t('data-lang-boxname-radial_opf')}
								</div>
							</TooltipHost>
						</Card.Body> :
						<Card.Header className="card-header-compact">
							<Card.Title className="d-flex justify-content-between">
								<b>{inputParam_ComponentContent !== null ? (inputParam_ComponentContent.boardComponentTitle ?? t('data-lang-boxname-radial_opf')) : t('data-lang-boxname-radial_opf')}</b>
								<div className='toolbar d-flex'>
									<HEADER_TOOLBAR
										inputParam_BoardStructure={inputParam_BoardStructure}
										inputParam_Container={inputParam_Container}
									/>
								</div>
							</Card.Title>
						</Card.Header>
					}
				</>
			}
			<Card.Body className='h-100 pt-0'>
			
				{renderContent()}
			
			</Card.Body>
		</Card>
	}
	{
		inputParam_UseFake && renderContent()
	}
	</>
}

export default SG3KPI_RADIALOPF;